import React from "react";
import cx from "classnames";
import convert, { type HtmrOptions } from "htmr";
import { ReactElement } from "react";
import { AllHTMLAttributes } from "react";

export interface XtSvgProps {
  icon?: string;
  src?: string;
  style?: StyleProps;
  className?: string;
  size?: number;
  width?: number | string;
  height?: number | string;
  color?: string;
}

const XtSvg: React.FC<XtSvgProps> = ({ className, icon, src = "", style, color, size, width, height }) => {
  const combineStyle = (w?: number, h?: number) => {
    return {
      fontSize: size ? size + "px" : "",
      width: width ? (typeof width === "number" ? width + "px" : width) : w || "",
      height: height ? (typeof height === "number" ? height + "px" : height) : h || "",
      color: color || "",
      ...style,
    };
  };
  const getSrcSvg = () => {
    const transform = {
      _: (nodeName: string, props: AllHTMLAttributes<HTMLElement> & ObjAny, children: React.ReactNode) => {
        if (nodeName === "svg") {
          // const vbs = props.viewBox.split(" ");
          // const w = vbs[2] > 200 ? 200 : vbs[2] < 12 ? 12 : vbs[2];
          // const h = vbs[3]> 200 ? 200 : vbs[3] < 12 ? 12 : vbs[3];

          props.style = { ...props.style, ...combineStyle() };
          props.className = cx("inline-icon", className);
        }
        if (nodeName === "lineargradient") {
          nodeName = "linearGradient";
        }
        if ((style && style.color) || color) {
          props.fill = "currentColor";
        }
        return React.createElement(nodeName, props, children);
      },
    };
    return convert(src, { transform } as any) as ReactElement<any, any> | null;
  };

  return icon ? (
    <svg className={cx("iconpark-icon", className)} style={combineStyle()}>
      <use href={"#" + icon}></use>
    </svg>
  ) : (
    getSrcSvg()
  );
};

export default XtSvg;
